import { useState, type ReactElement } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchAudit, type AuditItem } from '../../api/admin.js';
import { formatDateTime, shortId } from '../../lib/format.js';

export function AuditPage(): ReactElement {
  const [action, setAction] = useState('');
  const [targetKind, setTargetKind] = useState('');
  const [cursor, setCursor] = useState<string | undefined>(undefined);

  const query = useQuery({
    queryKey: ['admin', 'audit', action, targetKind, cursor],
    queryFn: () =>
      fetchAudit({
        action: action || undefined,
        targetKind: targetKind || undefined,
        cursor,
      }),
  });

  return (
    <>
      <div className="page-header">
        <div>
          <h1 className="page-title">Audit log</h1>
          <p className="page-sub">Toda acción mutativa del backoffice queda registrada acá</p>
        </div>
        <div className="filters">
          <input
            placeholder="action"
            value={action}
            onChange={(e) => {
              setAction(e.target.value);
              setCursor(undefined);
            }}
          />
          <input
            placeholder="target_kind"
            value={targetKind}
            onChange={(e) => {
              setTargetKind(e.target.value);
              setCursor(undefined);
            }}
          />
        </div>
      </div>
      {query.isPending ? (
        <div className="loading">Cargando…</div>
      ) : query.isError ? (
        <div className="loading">Error: {(query.error).message}</div>
      ) : (
        <section className="card">
          <table className="data-table">
            <thead>
              <tr>
                <th>When</th>
                <th>Admin</th>
                <th>Action</th>
                <th>Target</th>
                <th>Metadata</th>
              </tr>
            </thead>
            <tbody>
              {query.data.items.length === 0 ? (
                <tr>
                  <td colSpan={5} className="empty">Sin entradas</td>
                </tr>
              ) : (
                query.data.items.map((it) => <AuditRow key={it.id} item={it} />)
              )}
            </tbody>
          </table>
          {query.data.nextCursor && (
            <div className="pager">
              <button type="button" className="btn-secondary" onClick={() => setCursor(query.data.nextCursor)}>
                Siguiente página
              </button>
            </div>
          )}
        </section>
      )}
    </>
  );
}

function AuditRow({ item }: { item: AuditItem }): ReactElement {
  return (
    <tr>
      <td>{formatDateTime(item.at)}</td>
      <td>{item.adminEmail ?? shortId(item.adminUserId)}</td>
      <td><code>{item.action}</code></td>
      <td>
        {item.targetKind}:<code>{shortId(item.targetId)}</code>
      </td>
      <td>
        <pre className="code-block-inline">{JSON.stringify(item.metadata)}</pre>
      </td>
    </tr>
  );
}
